// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary {
  background: var(--theme-main-background-color, #055C8D);
  border-radius: 8px;
  outline: none;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.331373px;
  color: #FFFFFF;
  border: none;
  width: -moz-fit-content;
  width: fit-content;
  height: 34px;
  white-space: nowrap;
  min-width: 80px;
}

.primary:hover {
  background: var(--theme-main-darker-color, #055C8D);
  border-radius: 8px;
  outline: none;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.331373px;
  color: #FFFFFF;
  border: none;
  width: -moz-fit-content;
  width: fit-content;
  height: 34px;
  white-space: nowrap;
  min-width: 80px;
}

button.focus {
  outline: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
